"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.revisionWithFilesSchema = exports.revisionFileSchema = exports.revisionSchema = exports.revisionStatusSchema = void 0;
const z = require("zod");
const build_status_1 = require("./build-status");
const build_automation_1 = require("./build-automation");
exports.revisionStatusSchema = build_status_1.buildStatusSchema;
exports.revisionSchema = z.object({
    id: z.string(),
    status: exports.revisionStatusSchema,
    statusMessage: z.string().optional(),
    automationMode: build_automation_1.buildAutomationModeSchema.optional(),
    displayName: z.string().optional(),
    hasUploadedFiles: z.boolean(),
    erroredFromStatus: exports.revisionStatusSchema.optional(),
    createdAt: z.string(),
    updatedAt: z.string(),
});
exports.revisionFileSchema = z.object({
    id: z.string(),
    name: z.string(),
    uploadedAt: z.string(),
    size: z.string(),
    relativePath: z.string().optional(),
    uploadId: z.string().optional(),
});
exports.revisionWithFilesSchema = exports.revisionSchema.extend({
    files: z.array(exports.revisionFileSchema),
});
//# sourceMappingURL=revision.js.map